<template>
    <div class="vehicle-visitors d-flex flex-column align-items-center">
        <app-sub-title text="Ingresos de Vehículos" />
        <app-vehicle-visitors-filters v-model="filters" :on-filter="onFilter" />
        <b-row>
            <b-col>
                <b-btn
                    block
                    @click="reportVehicleVisits"
                    title="Descargar"
                    variant="primary"
                >
                    Descargar reporte ingreso de vehículos
                </b-btn>
            </b-col>
        </b-row>
        <div class="alert alert-info" v-if="!data.data || !data.data.length">
            <h4>No hay información</h4>
        </div>
        <app-vehicle-visitors-table v-if="!!data.data" :data="data.data" />
        <div class="pagination d-flex justify-content-center">
            <app-paginator
                v-if="!!data.data"
                :current-page="data.current_page"
                :last-page="data.last_page"
                :total="data.total"
                :from="data.from"
                :to="data.to"
                :on-change-page="onChangePage"
            />
        </div>
    </div>
</template>
<script>
import SubTitle from '../../UI/Layout/SubTitle.vue'
import VehicleVisitorsFilters from './VehicleVisitorsFilters/VehicleVisitorsFilters.vue'
import VehicleVisitorsTable from './VehicleVisitorsTable/VehicleVisitorsTable.vue'
import vehiclesRepository from '../../../repositories/vehicles.repository'
import Paginator from '../../UI/Controls/Paginator/Paginator.vue'
export default {
    components: {
        appSubTitle: SubTitle,
        appVehicleVisitorsFilters: VehicleVisitorsFilters,
        appVehicleVisitorsTable: VehicleVisitorsTable,
        appPaginator: Paginator,
    },
    data() {
        return {
            filters: '',
            page: 1,
            data: '',
        }
    },
    methods: {
        reportVehicleVisits() {
            const filters = { ...this.filters, clientId: this.client.id }
            const params = []
            _.forIn(filters, (value, key) => {
                if (!value) return
                params.push(`${key}=${value}`)
            })

            const queryString = params.join('&')
            window.open(
                `web/v1/vehicle-entries/client-export?` + queryString,
                '_blank'
            )
        },
        async loadEntries() {
            const vr = Object.assign({}, vehiclesRepository)
            try {
                const data = await vr.getVehicleEntriesByClient(
                    this.client.id,
                    this.page,
                    this.filters
                )
                this.data = data
            } catch (error) {
                toastr.error(
                    'Ocurrió un error al cargar la información de ingresos'
                )
            }
        },
        onChangePage(page) {
            this.page = page
            this.loadEntries()
        },
        onFilter() {
            this.page = 1
            this.loadEntries()
        },
    },
    created() {
        this.loadEntries()
    },
}
</script>
